import { SdkContext } from '../internal'

export class PaymentMethodsResource {
  constructor(private ctx: SdkContext) {}

  async list(): Promise<any[]> {
    const result = await this.ctx.raw<any[]>({ httpMethod: 'GET', path: '/members/me/payment-methods' })
    const methods = Array.isArray(result) ? result : (result as any)?.data ?? []
    return methods.map((method: any) => ({
      id: method.id,
      type: method.type,
      isDefault: method.isDefault,
      createdAt: method.createdAt,
      cardBrand: method.brand,
      cardLastDigits: method.last4,
      cardHolderName: method.holderName,
      cardExpiryMonth: method.expiryMonth,
      cardExpiryYear: method.expiryYear
    }))
  }

  async create(data: any): Promise<any> {
    return this.ctx.call({ httpMethod: 'POST', path: '/members/me/payment-methods', hasBody: true }, { body: data })
  }

  async setDefault(id: string): Promise<void> {
    await this.ctx.call({ httpMethod: 'POST', path: `/members/me/payment-methods/{id}/set-default` }, { id })
  }

  async delete(id: string): Promise<void> {
    await this.ctx.call({ httpMethod: 'DELETE', path: `/members/me/payment-methods/{id}` }, { id })
  }
}
